import {useDispatch, useSelector} from 'react-redux';


import orderService from '../../../../services/OrderService';

import {orderActions, orderSelectors} from '../index';

import useIsOrderSummaryLoaded from './useIsOrderSummaryLoaded';


/**
 * Loads the given order summary
 *
 * @param orderId {string} Order id to load
 * @return {object} Order or null if not loaded
 */
function useOrder(orderId) {

    const isOrderLoaded = useIsOrderSummaryLoaded(orderId);
    const order = useSelector(state => orderSelectors.getOrderSummary(state, orderId));
    const dispatch = useDispatch();

    if (isOrderLoaded) {

        return order;
    }

    (async () => {

        const loadedOrder = await orderService.getOrderSummary(orderId);
        dispatch(orderActions.onOrderSummaryLoaded(loadedOrder));
    })();

    return order;
}


export default useOrder;
